import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "home" */ './views/Home')
    },
    // {
    //   path: '/contact',
    //   name: 'contact',
    //   component: () => import(/* webpackChunkName: "contact" */ './views/contact')
    // },
    {
      path: '/football/today/1221',
      name: 'football-today-1221',
      // route level code-splitting
      // this generates a separate chunk (today.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "football-today-1221" */ './views/football/today/1221')
    },
    {
      path: '/football/today/1x2',
      name: 'football-today-1x2',
      component: () => import(/* webpackChunkName: "football-today-1x2" */ './views/football/today/1x2')
    },
    {
      path: '/football/today/xht',
      name: 'football-today-xht',
      component: () => import(/* webpackChunkName: "football-today-xht" */ './views/football/today/xht')
    },
    {
      path: '/football/today/xft',
      name: 'football-today-xft',
      component: () => import(/* webpackChunkName: "football-today-xft" */ './views/football/today/xft')
    },
    {
      path: '/football/today/xhtft',
      name: 'football-today-xhtft',
      component: () => import(/* webpackChunkName: "football-today-xhtft" */ './views/football/today/xhtft')
    },
    {
      path: '/football/today/btts',
      name: 'football-today-btts',
      component: () => import(/* webpackChunkName: "football-today-btts" */ './views/football/today/btts')
    },
    {
      path: '/football/today/over05ht',
      name: 'football-today-over05ht',
      component: () => import(/* webpackChunkName: "football-today-over05ht" */ './views/football/today/over05ht')
    },
    {
      path: '/football/today/over15ht',
      name: 'football-today-over15ht',
      component: () => import(/* webpackChunkName: "football-today-over15ht" */ './views/football/today/over15ht')
    },
    {
      path: '/football/today/over25ft',
      name: 'football-today-over25ft',
      component: () => import(/* webpackChunkName: "football-today-over25ft" */ './views/football/today/over25ft')
    },
    {
      path: '/football/today/over35ft',
      name: 'football-today-over35ft',
      component: () => import(/* webpackChunkName: "football-today-over35ft" */ './views/football/today/over35ft')
    },
    {
      path: '/football/tomorrow/1x2',
      name: 'football-tomorrow-1x2',
      component: () => import(/* webpackChunkName: "football-tomorrow-1x2" */ './views/football/tomorrow/1x2')
    },
    {
      path: '/football/tomorrow/xht',
      name: 'football-tomorrow-xht',
      component: () => import(/* webpackChunkName: "football-tomorrow-xht" */ './views/football/tomorrow/xht')
    },
    {
      path: '/football/tomorrow/xft',
      name: 'football-tomorrow-xft',
      component: () => import(/* webpackChunkName: "football-tomorrow-xft" */ './views/football/tomorrow/xft')
    },
    {
      path: '/football/tomorrow/xhtft',
      name: 'football-tomorrow-xhtft',
      component: () => import(/* webpackChunkName: "football-tomorrow-xhtft" */ './views/football/tomorrow/xhtft')
    },
    {
      path: '/football/tomorrow/1221',
      name: 'football-tomorrow-1221',
      component: () => import(/* webpackChunkName: "football-tomorrow-1221" */ './views/football/tomorrow/1221')
    },
    {
      path: '/football/tomorrow/btts',
      name: 'football-tomorrow-btts',
      component: () => import(/* webpackChunkName: "football-tomorrow-btts" */ './views/football/tomorrow/btts')
    },
    {
      path: '/football/tomorrow/over05ht',
      name: 'football-tomorrow-over05ht',
      component: () => import(/* webpackChunkName: "football-tomorrow-over05ht" */ './views/football/tomorrow/over05ht')
    },
    {
      path: '/football/tomorrow/over15ht',
      name: 'football-tomorrow-over15ht',
      component: () => import(/* webpackChunkName: "football-tomorrow-over15ht" */ './views/football/tomorrow/over15ht')
    },
    {
      path: '/football/tomorrow/over25ft',
      name: 'football-tomorrow-over25ft',
      component: () => import(/* webpackChunkName: "football-tomorrow-over25ft" */ './views/football/tomorrow/over25ft')
    },
    {
      path: '/football/tomorrow/over35ft',
      name: 'football-tomorrow-over35ft',
      component: () => import(/* webpackChunkName: "football-tomorrow-over35ft" */ './views/football/tomorrow/over35ft')
    },
    {
      path: '/handball/today/xht',
      name: 'handball-today-xht',
      component: () => import(/* webpackChunkName: "handball-today-xht" */ './views/handball/today/xht')
    },
    {
      path: '/handball/today/xft',
      name: 'handball-today-xft',
      component: () => import(/* webpackChunkName: "handball-today-xft" */ './views/handball/today/xft')
    },
    {
      path: '/handball/today/xhtft',
      name: 'handball-today-xhtft',
      component: () => import(/* webpackChunkName: "handball-today-xhtft" */ './views/handball/today/xhtft')
    },
    {
      path: '/handball/tomorrow/xht',
      name: 'handball-tomorrow-xht',
      component: () => import(/* webpackChunkName: "handball-tomorrow-xht" */ './views/handball/tomorrow/xht')
    },
    {
      path: '/handball/tomorrow/xft',
      name: 'handball-tomorrow-xft',
      component: () => import(/* webpackChunkName: "handball-tomorrow-xft" */ './views/handball/tomorrow/xft')
    },
    {
      path: '/handball/tomorrow/xhtft',
      name: 'handball-tomorrow-xhtft',
      component: () => import(/* webpackChunkName: "handball-tomorrow-xhtft" */ './views/handball/tomorrow/xhtft')
    },
    {
      path: '/error',
      name: 'error',
      component: () => import(/* webpackChunkName: "error" */ './views/error')
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "error" */ './views/privacy-policy')
    }
  ]
})
